<template>
  <div>
    <PageAllow controller="FinanceBills" action="edit" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherFinanceMaterialCategory v-model="categorySelected" />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />

              <v-btn
                small
                color="success"
                dark
                class="ms-1"
                @click.stop="save()"
              >
                <v-icon x-small class="pe-1">fas fa-save</v-icon>
                {{ $t("financeBillBatchEdit.save") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="key_word"
                    v-model="options.key_word"
                    @text="KeyWord = $event"
                    :label="$t('financeBillBatchEdit.key_word')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            item-key="material_id"
            :headers="headers"
            :items="editItems"
            :loading="loading"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            :expanded.sync="expanded"
            show-expand
            class="elevation-2 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.data-table-expand="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <!-- v-for="(v,i) in finance_bill_details" -->
            <template v-slot:expanded-item="{ item }">
              <td class="pa-0">
                <div
                  style="height: 50px"
                  v-for="(v, i) in finance_bill_details(item.material_id)"
                  :key="i"
                >
                  单号：{{ v.order_code }}
                </div>
              </td>
              <td class="pa-0">
                <div
                  style="height: 50px"
                  v-for="(v, i) in finance_bill_details(item.material_id)"
                  :key="i"
                >
                  单位：{{ v.unit }}
                </div>
              </td>
              <td class="pa-0">
                <div
                  style="height: 50px"
                  v-for="(v, i) in finance_bill_details(item.material_id)"
                  :key="i"
                >
                  数量：{{ v.num }}
                </div>
              </td>

              <td class="pa-0">
                <div
                  style="height: 50px"
                  v-for="(v, i) in finance_bill_details(item.material_id)"
                  :key="i"
                >
                  <v-text-field
                    v-model="v.price"
                    :placeholder="$numberFormatter.formatTwoDot(v.price, 2)"
                    single-line
                    dense
                    hide-details
                    type="number"
                    min="0"
                    :prefix="$t('Global.money')"
                    @blur="
                      v.price = $numberFormatter.formatWithDotNoMoreThan(
                        v.price,
                        2
                      )
                    "
                    style="max-width: 80px; margin-left: auto"
                  />
                </div>
              </td>
              <td class="pa-0">
                <div
                  style="height: 50px"
                  v-for="(v, i) in finance_bill_details(item.material_id)"
                  :key="i"
                >
                  小计：{{ $t("Global.money")
                  }}{{ (v.num * v.price) | formatMoneyFloor }}
                </div>
              </td>
              <td class="pa-0">
                <div
                  style="height: 50px"
                  v-for="(v, i) in finance_bill_details(item.material_id)"
                  :key="i"
                >
                  <v-text-field
                    v-model="v.memo"
                    single-line
                    dense
                    hide-details
                    style="max-width: 120px"
                  >
                    <template v-slot:append>
                      <v-icon
                        x-small
                        @click.stop="
                          detail_memo_item = v;
                          memoDialog = true;
                        "
                        class="pt-2 pb-1 primary--text"
                      >
                        fa-edit
                      </v-icon>
                    </template>
                  </v-text-field>
                </div>
              </td>
            </template>

            <template v-slot:item.sum="{ item }">
              {{ $t("Global.money") }}
              {{ (item.num * item.price) | formatMoney }}
            </template>

            <template v-slot:item.price="{ item }">
              <v-text-field
                v-model="item.price"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.price = $numberFormatter.formatWithDotNoMoreThan(
                    item.price,
                    2
                  )
                "
              />
            </template>

            <!-- 单价 -->
            <!-- <template v-slot:item.price="{ item }">
              <v-text-field
                v-model="item.price"
                :placeholder="$numberFormatter.formatTwoDot(item.price, 2)"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.price = $numberFormatter.formatWithDotNoMoreThan(
                    Number(item.price),
                    2
                  )
                "
              />
            </template> -->
            <!-- 数量 -->
            <!-- <template v-slot:item.num="{ item }">
              <v-text-field
                v-model="item.num"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                @blur="
                  item.num = $numberFormatter.formatWithDotNoMoreThan(
                    Number(item.num),
                    2
                  )
                "
              />
            </template> -->
            <!-- 备注 -->
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>

    <!-- 备注弹窗 -->
    <v-dialog v-model="memoDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span class="d-inline-block text-center" style="max-width: 360px">
            {{ $t("financeBillBatchEdit.memo") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memoDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memoDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherFinanceMaterialCategory from "@/components/plugins/SearcherFinanceMaterialCategory";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import FinanceBills from "@/api/finance_bills";

const defaultOptions = {
  material_category_ids: null,
  key_word: "",
};

export default {
  data: () => ({
    expanded: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    categorySelected: null,
    editItems: [],
    finance_bill_detail: [],
    detail_memo_item: { memo: "" },
    memoDialog: false,
    materialIdArr: [],
    ary: [],
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherFinanceMaterialCategory,
    SearcherKeyword,
  },
  computed: {
    finance_bill_details() {
      return function (id) {
        if (this.ary.filter((v) => v.materialId == id)[0]) {
          return this.ary.filter((v) => v.materialId == id)[0].objAry;
        }
      };
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.inanceReceipt"),
        disabled: false,
        href: "/finance-receipt",
      },
      {
        text: i18n.t("Nav.financeBillBatchEdit"),
        disabled: true,
      },
    ],

    headers() {
      return [
        {
          text: i18n.t("financeBillBatchEdit.Fields.material_category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("financeBillBatchEdit.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("financeBillBatchEdit.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("financeBillBatchEdit.Fields.price"),
          align: "end",
          sortable: false,
          value: "price",
          width: "120px",
        },
        {
          text: "",
          align: "end",
          sortable: false,
          value: "",
          width: "120px",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "data-table-expand",
          width: "120px",
        },
      ];
    },

    ...mapState(["loading"]),
  },

  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        key_word: this.KeyWord,
      });
      this.getFinanceBill();
    },
    resetSearch() {
      this.categorySelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    // 获取商品列表
    getFinanceBill() {
      FinanceBills.fetchBatchEdit(
        this.$route.query.financeBillIds,
        this.options
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.editItems = response.data.materials;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },

    // 根据商品获取财务调整单详情
    getByMaterial() {
      // 获取商品id []
      if (this.editItems.length) {
        this.editItems.map((e) => {
          this.materialIdArr.push(e.material_id);
        });
      }
      //   this.materialIdArr = this.materialIdArr.map((v) => {
      //     return new Promise((resovle) => {
      //       FinanceBills.fetchByMaterial(
      //         v,
      //         this.$route.query.financeBillIds
      //       ).then((res) => {
      //         resovle(res);
      //       });
      //     });
      //   });
      //   return Promise.all(this.materialIdArr).then((res) => {
      //         console.log(res);
      //   });

      for (let i of this.materialIdArr) {
        // console.log("商品id", i);
        FinanceBills.fetchByMaterial(i, this.$route.query.financeBillIds).then(
          function (response) {
            if (response.data.status.isOK()) {
              const obj = {};
              (obj.materialId = i),
                (obj.objAry = response.data.finance_bill_details);
              this.ary.push(obj);
            }
          }.bind(this)
        );
      }
      //   console.log("详情", this.ary);
    },

    save() {
      //   console.log("ary", this.ary);
      //   console.log("editItems", this.editItems);

      let material_price = [];
      for (let i of this.editItems) {
        const material_obj = {};
        material_obj.material_id = i.material_id;
        if (i.price) {
          material_obj.price = i.price;
        }
        material_price.push(material_obj);
      }

      //   console.log("material_price",material_price);

      var detail_price = [];
      this.ary.map((v) => {
        v.objAry.map((e) => {
          detail_price.push({
            finance_detail_ids: [Number(e.finance_bill_detail_ids)],
            price: e.price,
          });
        });
      });
      //   console.log('detail_price',detail_price);
      var finance_bill_ids = [];
      finance_bill_ids.push(this.$route.query.financeBillIds);
      finance_bill_ids = finance_bill_ids[0].split(",").map((v) => +v);
      //   console.log("finance_bill_ids",finance_bill_ids);
      //   console.log({ finance_bill_ids, material_price, detail_price });
      FinanceBills.batchEdit({
        finance_bill_ids,
        material_price,
        detail_price,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            window.parent.parent.location.href = "/#/finance-bills";
          }
        }.bind(this)
      );
    },
  },

  mounted() {
    let _this = this;
    setTimeout(function () {
      _this.getByMaterial();
    }, 2000);
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getFinanceBill();
      },
    },
    categorySelected: {
      handler() {
        this.options.material_category_ids = this.categorySelected
          ? this.categorySelected.id
          : null;
      },
    },

    editItems: {
      deep: true,
      handler() {
        this.editItems.forEach((e) => {
          if (e.price) {
            this.ary.forEach((item) => {
              if (item.materialId == e.material_id) {
                item.objAry.map((v) => {
                  v.price = e.price;
                });
              }
            });
          }
        });
      },
    },
  },
};
</script>

<style>
</style>